import axios from '@/libs/api.request'

// 获取配送费设置列表
export function getDeliveryFeeList () {
  return axios.request({
    url: '/print/delivery/list',
    method: 'get'
  })
}

// 保存配送费设置（新增/修改）
export function saveDeliveryFee (data) {
  return axios.request({
    url: '/print/delivery/save',
    method: 'post',
    data
  })
}

// 删除配送费设置
export function deleteDeliveryFee (data) {
  return axios.request({
    url: '/print/delivery/delete',
    method: 'post',
    data
  })
}

// 获取配送费设置详情
export function getDeliveryFeeDetail (params) {
  return axios.request({
    url: '/print/delivery/detail',
    method: 'get',
    params
  })
}
